import React, { JSX } from 'react';

import { Panel, Panels, spacing, usePublicaTranslation } from '~/src/dash/publicaUI';
import { AdBreaksTable } from '~/src/dash/views/inventory-rules-v2/AdBreaks/AdBreaksTable';
import { TopBar } from '~/src/dash/views/topbar/TopBar';

export const AdBreaksList = (): JSX.Element => {
  const { t } = usePublicaTranslation();
  return (
    <Panels max vertical relative minWidthMain>
      <Panel largeHorizontalPadding paddingTop={spacing.small} paddingBottom={spacing.extraLarge}>
        <TopBar title={t('InventoryRulesAdBreakSchedules')} enableUINotices />
      </Panel>
      <Panels max vertical relative minWidthMain scroll>
        {/* ADD WHEN FORMS ARE IMPLEMENTED */}
        {/* <Panel largeHorizontalPadding style={{ alignSelf: 'flex-end' }}>
          <ButtonV2
            small
            onClick={() => undefined}
            tKey='PlusAddItem'
            tProps={{ item: t('AdBreak') }}
          />
        </Panel> */}
        <Panel>
          <AdBreaksTable />
        </Panel>
      </Panels>
    </Panels>
  );
};
